import { produce } from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { LocationGroupTypes } from '../../types';
import { convertLocationGroupResponse, getChildItemToPushList } from '../../utils';
import { storeName as mapLocationEntityStore } from './mapLocation.entity';
import { storeName as layoutModelStore } from '../models/layout.model';
import { storeName as projectModelStore } from '../models/project.model';
import { getDetailGroupByKey } from '../../services/locationGroup.service';
import { getProjectLocationGroups } from '../../services/project.service';
import { LocationGroupResponseTypes } from '../../types/response';

export const storeName = 'locationGroupEntity';

export const locationGroupEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: LocationGroupTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.id] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof locationGroupEntity>) => ({
    async loadByProjectKey(_, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const { projectCode } = state[projectModelStore];

      if (!projectCode) return;
      const resp: LocationGroupResponseTypes[] = await getProjectLocationGroups(
        projectCode,
        locale.apiLanguage
      );

      const groups = [];
      const locationGroups = (resp || []).map((i) => convertLocationGroupResponse(i));
      const result = getChildItemToPushList(locationGroups, groups);

      this.saves(result.groups);
      return { groups: result.groups, items: result.items };
    },
    async loadById(payload: number, state: RootModel) {
      dispatch[layoutModelStore].setLoading(true);
      const { locale } = state[layoutModelStore];
      const entities: LocationGroupTypes[] = state[storeName].ids;
      const item = entities[payload];

      if (!item) return;
      if (!item.isSimplified) {
        return item;
      }

      const resp: LocationGroupResponseTypes = await getDetailGroupByKey(
        item.code,
        locale.apiLanguage
      );
      const newItem: LocationGroupTypes = convertLocationGroupResponse(resp);

      dispatch[mapLocationEntityStore].saves(newItem.items);
      this.saves([newItem]);

      return newItem.items;
    },
  }),
});

export default locationGroupEntity;
